import { useSymbolStore } from '@/stores/symbol';
import PanelContainer from '../panel-container';
import SymbolContainer from '../symbol-container';
import CustomStickerBlocks from './custom-sticker-blocks';

const CustomStickerPanel = () => {
  const selectedSymbol = useSymbolStore((s) => s.selectedSymbol);

  return (
    <PanelContainer visible={selectedSymbol === 'custom-sticker'}>
      <SymbolContainer slug={selectedSymbol}>
        <CustomStickerBlocks />
      </SymbolContainer>
    </PanelContainer>
  );
};

export default CustomStickerPanel;
